//
// Imports
//

import { z } from "zod";

//
// Schemas
//

export const IdSchema = z.coerce.number().int().min(1);

export const DisplayNameSchema = z
	.string()
	.trim()
	.max(64, "Your display name must be no more than 64 characters long. Note that certain characters count as more than one character.")
	.transform((value) => value == "" ? null : value);

export const EmailSchema = z
	.string(
		{
			message: "You must enter an email address.",
		})
	.email(
		{
			message: "You must enter a valid email address.",
		})
	.min(3, "Your email address must be at least 3 characters long.")
	.max(255, "Your email address must be no more than 255 characters long.");

export const PasswordSchema = z
	.string(
		{
			message: "You must enter a password.",
		})
	.min(1, "You must enter a password.")
	.max(72, "Your password must be no more than 72 characters long.");

export const UsernameSchema = z
	.string()
	.min(3, "Your username must be at least 3 characters long.")
	.max(32, "Your username must be no more than 32 characters long.")
	.refine(
		(value) => !/^[0-9]+$/.test(value),
		{
			message: "Your username cannot be a number.",
		})
	.refine(
		(value) => /^[a-z0-9._-]+$/i.test(value),
		{
			message: "Your username can only contain letters, numbers, underscores and dashes.",
		})
	.refine(
		(value) => !/[-_.]{2,}/.test(value),
		{
			message: "Your username cannot contain multiple underscores, dashes or dots in a row.",
		});